module.exports = __webpack_public_path__ + "static/media/jboxlogo.71d0cbc7.png";